/* Harris Auto — cart controller backed by the real Shopify AJAX Cart API.
   Preserves the prototype's event model (harriscart:change / harriscart:open)
   so the header badge, slide-out drawer, and cart page stay in sync.
   Every add attaches a "Fits" line-item property from the garage vehicle. */
(function () {
  var _cart = null;

  function moneyFormat() {
    return (window.Shopify && window.Shopify.money_format) || "${{amount}}";
  }

  /* Format cents using the shop's money_format string. */
  function money(cents) {
    var value = (cents || 0) / 100;
    var fmt = moneyFormat();
    function fmtNum(precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      var n = value.toFixed(precision);
      var parts = n.split(".");
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case "amount": return fmtNum(2);
        case "amount_no_decimals": return fmtNum(0);
        case "amount_with_comma_separator": return fmtNum(2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmtNum(0, ".", ",");
        default: return fmtNum(2);
      }
    });
  }

  function broadcast() {
    window.dispatchEvent(new CustomEvent("harriscart:change", { detail: _cart }));
  }

  function get(force) {
    if (_cart && !force) return Promise.resolve(_cart);
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { _cart = c; broadcast(); return c; });
  }

  function add(variantId, quantity, extraProps) {
    var props = extraProps || {};
    var g = window.HarrisGarage && window.HarrisGarage.read();
    if (g && !props.Fits) props.Fits = window.HarrisGarage.label(g);
    var body = {
      items: [{ id: Number(variantId), quantity: quantity || 1, properties: props }],
    };
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return get(true); })
      .then(function (c) {
        window.dispatchEvent(new CustomEvent("harriscart:open"));
        return c;
      });
  }

  /* Add by submitting a native product form via AJAX. FormData serializes every
     input inside the form — including inputs injected by options apps (Easify) —
     so custom option properties ride along into the line item. */
  function addForm(formEl) {
    var fd = new FormData(formEl);
    var g = window.HarrisGarage && window.HarrisGarage.read();
    if (g && !fd.has("properties[Fits]")) fd.append("properties[Fits]", window.HarrisGarage.label(g));
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return get(true); })
      .then(function (c) {
        window.dispatchEvent(new CustomEvent("harriscart:open"));
        return c;
      });
  }

  /* change by line key (Shopify line item key, e.g. "398...:abc") */
  function changeByKey(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { _cart = c; broadcast(); return c; });
  }

  function remove(key) { return changeByKey(key, 0); }

  function count() { return _cart ? _cart.item_count : 0; }
  function open() { window.dispatchEvent(new CustomEvent("harriscart:open")); }

  window.HarrisCart = {
    get: get,
    add: add,
    addForm: addForm,
    changeByKey: changeByKey,
    remove: remove,
    count: count,
    open: open,
    money: money,
    current: function () { return _cart; },
  };

  document.addEventListener("DOMContentLoaded", function () { get(true); });

  /* Delegated add-to-cart for product cards (data-add-to-cart).
     data-variant-id → add that variant; data-product-url → navigate (multi-variant). */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-add-to-cart]");
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute("data-variant-id");
    var url = btn.getAttribute("data-product-url");
    if (variantId) {
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = "Adding…";
      add(variantId, 1).then(function () {
        btn.disabled = false; btn.textContent = label;
      }).catch(function (err) {
        console.error("Harris cart: add to cart failed", err);
        btn.disabled = false; btn.textContent = "Try Again";
        setTimeout(function () { btn.textContent = label; }, 2500);
      });
    } else if (url) {
      window.location.href = url;
    }
  });
})();
